<template>
  <div class="impersonation" role="status" data-testid="impersonation-banner">
    <EyeIcon class="impersonation__icon" />
    <span class="impersonation__text">
      {{ $t('profile.impersonating', { user: userName, admin: adminName }) }}
    </span>
    <button
      type="button"
      class="impersonation__exit"
      :disabled="leaving"
      data-testid="impersonation-exit"
      @click="$emit('exit')"
    >
      {{ $t('profile.impersonation_exit') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { EyeIcon } from '@heroicons/vue/24/outline'

defineProps<{
  userName: string
  adminName: string
  leaving?: boolean
}>()

defineEmits<{ exit: [] }>()
</script>

<style scoped lang="scss">
.impersonation {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: var(--cds-support-warning, #f1c21b);
  color: var(--cds-text-primary, #161616);
  font-size: 0.875rem;
}

.impersonation__icon {
  width: 1.125rem;
  height: 1.125rem;
  flex-shrink: 0;
}

.impersonation__text {
  flex: 1;
}

.impersonation__exit {
  border: 1px solid currentColor;
  background: transparent;
  color: inherit;
  padding: 0.25rem 0.75rem;
  border-radius: 0.25rem;
  cursor: pointer;
  font: inherit;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}
</style>
